<form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
  <h5 class="card-header"> {{ trans.CalTagValidationMessage| translate}}</h5>

  <table class="custom-table">
    <th> {{ trans.Name| translate}}</th>
    <th> {{ trans.type| translate}}</th>
    <th> {{ trans.Value| translate}}</th>
    <tr *ngFor="let selectedItems of selectedItemsForm; let i = index" class="list-group list-group-flush">
      <td class="col-md-4 col-12">
        {{ allUsedItems[i].name +' '+ allUsedItems[i].itemType }}
      </td>
      <td class="col-md-4 col-12"> {{ allUsedItems[i].type}} </td>
      <td class="col-md-2 col-12 value-field">
        <div [formGroup]="selectedItems" class="form-row">
          <div class="form-group col-2">
            <mat-form-field appearance="outline">
              <mat-label *ngIf="(allUsedItems[i].type !== dataTypes.Number)">e.g abc
              </mat-label>
              <mat-label *ngIf="allUsedItems[i].type === dataTypes.Number">e.g 123 </mat-label>
              <input matInput formControlName="value" [pattern]="allUsedItems[i].type === dataTypes.Number ? '^[+-]?[0-9.]*$' : '^[a-zA-Z]([a-zA-Z0-9_-]?)+$'"
                autocomplete="off" class="form-control" />
            </mat-form-field>
          </div>
        </div>
      </td>
    </tr>
  </table>

  <div class="text-center footer">
    <button mat-flat-button (click)="onClose()" style="float: left"> {{ trans.Cancel| translate}}</button>
    <button mat-flat-button color="primary" [disabled]="dynamicForm.invalid" style="float: right" (click)="onSubmit()">
      {{ trans.Submit| translate}}
    </button>
  </div>
</form>